<template>
    <div>
        <Layout :header="{ text: '雲端e櫃檯', backBtn: { visible: false }, closeBtn: { visible: false, to: {} } }">
            <template #top>
                <div v-if="!checkMaintenance" class=" bg-white border-b border-[#dadada]">
                    <div class="tabs flex max-w-3xl mx-auto px-4">
                        <button @click="(e) => { goTab(i); }" class="tabs__btn py-3 w-1/2 relative"
                            :class="{ 'active': tabIndex === i }" v-for="(item, i) in ['預約申請', '查詢/取消預約資料']" :key="i">{{
                                item
                            }}
                        </button>
                    </div>
                </div>
            </template>
            <!-- 預約申請 -->
            <div v-if="!checkMaintenance" v-show="tabIndex === 0">
                <ul class="link-list">
                    <li class="mb-3" v-for="(apl, idx) in pageData.aplList" :key="idx" @click="next(apl)">
                        <div
                            class="link-list__item__link w-full flex justify-between p-4 bg-white shadow-sm rounded-md font-bold fill-[#0093C1]">
                            <span>{{ apl.name }}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                style="width: 18px; height: 18px;">
                                <title>chevron-right</title>
                                <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                            </svg>
                        </div>
                    </li>
                </ul>
                <Loading :is-loading="pageData.isLoading" />
            </div>
            <!-- 查詢取消預約資料 -->
            <div v-show="tabIndex === 1">

                <!-- 有資料 -->
                <template v-if="caseData">
                    <CaseBox :caseBox="caseBox" v-for="(caseBox, i) in caseData" :key="i" />
                </template>
                <!-- 無資料 -->
                <div v-else class="text-center absolute top-1/4 left-1/2 -translate-x-1/2">
                    <span class="inline-block">
                        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="6" y="6" width="42" height="47" fill="#C3C3C3" />
                            <circle cx="46" cy="46" r="15" fill="#C3C3C3" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M48 31.1322V53H32.7301C31.6255 50.9103 31 48.5282 31 46C31 37.7157 37.7157 31 46 31C46.6781 31 47.3457 31.045 48 31.1322Z"
                                fill="#686868" />
                            <rect x="12" y="16" width="27" height="4" fill="#F0F0F0" />
                            <rect x="12" y="27" width="18" height="4" fill="#F0F0F0" />
                            <rect x="51" y="58.5273" width="6" height="12" transform="rotate(-36 51 58.5273)"
                                fill="#C3C3C3" />
                        </svg>
                    </span>
                    <p class="text-nowrap">你目前沒有預約資料</p>
                </div>

            </div>
            <Loading :is-loading="pageData.isLoading" />
            <InfoBox v-if="signBox1.show" :closeHandel="() => { signBox1.show = false }" :title="signBox1.title"
                type="confirm" :okHandel="signBox1.okHandel" :buttonText="signBox1.buttonText">
                <div v-html="signBox1.message" />
            </InfoBox>
            <InfoBox v-if="signBox2.show" :closeHandel="() => { signBox2.show = false }" :title="signBox2.title"
                :okHandel="signBox2.okHandel" :buttonText="signBox2.buttonText">
                <div v-html="signBox2.message" />
            </InfoBox>
            <InfoBox v-if="bailout.show" :closeHandel="() => { signBox2.show = false }" :cancelHandel="bailout.backHome"
                :title="bailout.title" type="confirm" :okHandel="bailout.okHandel"
                :buttonText="{ no: '取消', yes: '繼續借款' }">
                <div v-html="bailout.message" />
            </InfoBox>
            <InfoBox v-if="maintenance.show" :title="maintenance.title"
                :okHandel="maintenance.okHandel" :buttonText="maintenance.buttonText">
                <div v-html="maintenance.message" />
            </InfoBox>            
            <Modal v-model:visibleModal="visibleModal" :notice-list="noticeList" />
        </Layout>
    </div>
</template>

<script setup>

import '@/assets/cloudCounter/css/style.css';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue'
import { inject, onMounted, reactive, ref } from 'vue';
import routeName from '@/router/constant.js';
import router from '@/router';
import { initTransaction, showReserverList } from '@/apis/CloudECounter';
// import serviceRoutes from '@/json/serviceRoutes';
import { useStore } from 'vuex';
import Loading from '@/components/Loading.vue';
import { startTransaction } from '@/apis/system';
import aplCatlCode from '@/json/aplCatlCode';
import serviceRoutes from '@/json/serviceRoutes';
import { openPopupCatch } from '@/utils/vfmUtils';
import { useRoute } from 'vue-router';
import Modal from '@/views/home/modal.vue';
import { getNoticeInfo, getPauseFunctionInfo } from '@/apis/notice';

const visibleModal = ref(false);
const noticeList = ref([]);
const checkMaintenance = ref(false);
const store = useStore();
const signBox1 = reactive({
    show: false,
    title: '目前僅能進行新台幣保單借款',
    message: '您的外幣保單尚未設定外幣匯款帳號，目前僅能進行新臺幣保單借款。如欲申請外幣保單借款，請至契約內容變更，設定「要保人指定匯款帳號」。',
    buttonText: {
        yes: '繼續借款'
    },
    okHandel: () => {
        signBox1.show = false;
        bailout.show = true;
    },
})

const signBox2 = reactive({
    show: false,
    title: '保單借款需要視訊確認才可完成',
    message: '提醒您！辦理「保單借款」須以視訊確認才可完成申請。',
    buttonText: {
        yes: '我知道了'
    },
    okHandel: () => {
        //signBox1.show = false;
        bailout.show = true;
        // pageData.isLoading = true;
        //startTransaction().then(res => {
        //    router.push({ name: routeName.CLOUD_E_COUNTER_LOAN_NOTICE }).catch(err => {
        //        console.log(err);
        //    });
        //}).finally(() => { pageData.isLoading = false; });
    },
})

const bailout = reactive({
    show: false,
    title: '',
    message: '提醒您！如需申請『經濟弱勢保戶保單借款優惠利率方案』，請至首頁使用「保單借款」功能，您也能親臨櫃檯或請您的服務人員協助辦理，如有問題，可洽詢免付費服務電話0809-026-688，造成您的不便，敬祈見諒！',
    buttonText: {
        yes: '我知道了'
    },
    okHandel: () => {
        pageData.isLoading = true;
        startTransaction().then(res => {
            router.push({ name: routeName.CLOUD_E_COUNTER_LOAN_NOTICE }).catch(err => {
                console.log(err);
            });
        }).finally(() => { pageData.isLoading = false; });
    },
    backHome: () => {
        window.location.href = 'applink://back_home';
    },
})

const maintenance = reactive({
    show: false,
    title: '',
    message: '目前雲端e櫃檯暫不開放使用，故無法提供您線上保單服務功能，請通知您的服務人員協助辦理,或洽詢免付費電話 0809-000-550 造成您的不便，敬祈見諒！',
    buttonText: {
        yes: '確認'
    },
    okHandel: () => {
        window.location.href = 'applink://back_home';
    }
})

const pageData = reactive({
    isLoading: true,
    checkOtp: false,
    aplList: [{
        aplCatl: aplCatlCode.LOAN,
        name: '保單借款',
        routeName: routeName.CLOUD_E_COUNTER_LOAN_NOTICE,
    }, {
        aplCatl: aplCatlCode.BENEIFCIARY,
        name: '受益人變更',
        routeName: routeName.CLOUD_E_COUNTER_POLICY,
    }, {
        aplCatl: aplCatlCode.APPLICANT_CHANGE,
        name: '要保人變更',
        routeName: routeName.CLOUD_E_COUNTER_POLICY,
    }, {
        aplCatl: aplCatlCode.APPLICANT_INSURED_NAME_CHANGE,
        name: '要保人或被保險人姓名變更',
        routeName: routeName.CLOUD_E_COUNTER_POLICY,
    }],
});
const route = useRoute();

const $vfm = inject('$vfm');
const next = (apl) => {
    pageData.isLoading = true;
    if (apl.aplCatl === aplCatlCode.LOAN) {
        confirmNextStepForLoan(apl);
        return;
    }
    $vfm.show({
        component: 'DialogBase',
        params: {
            title: `${apl.name}需要視訊確認才可完成`,
            content: '提醒您！辦理「' + apl.name + '」須以視訊確認才可完成申請。',
            confirmButton: '我知道了',
            cancelButton: null,
            closeicon: false,
        },
        on: {
            confirm() {
                $vfm.hide('DialogBase');
                confirmNextStep(apl);
            },
            closed() {
                $vfm.hide('DialogBase');
            },
        },
    });
};

const confirmNextStep = (apl) => {
    pageData.isLoading = true;
    initTransaction(apl.aplCatl).then((res) => {
        store.dispatch('services/setAplCatl', apl.aplCatl);
        store.dispatch('permissions/setTransactionId', res.data.transactionUniqueId);
        const index = serviceRoutes.findIndex(i => i.code === apl.aplCatl);
        const data = [{
            transactionItemName: apl.name,
            userChecked: true,
            transactionItemNo: apl.aplCatl,
            routeName: serviceRoutes[index].routeName,
        }];
        // for step route
        store.dispatch('services/setServices', data);
        // for 資料確認頁面
        store.dispatch('services/setTransactionItems', data);
        startTransaction().then(res => {
            router.push({ name: apl.routeName }).catch(err => {
                console.log(err);
            });
        });
        pageData.isLoading = false;
    }).catch((ex) => {
        pageData.isLoading = false;
        openPopupCatch({
            title: '暫時無法使用雲端e櫃檯',
            confirmButton: '我知道了',
            error: ex,
        });
    });
};

const confirmNextStepForLoan = (apl) => {
    pageData.isLoading = true;
    initTransaction(apl.aplCatl).then((res) => {
        store.dispatch('services/setAplCatl', apl.aplCatl);
        store.dispatch('permissions/setTransactionId', res.data.transactionUniqueId);
        const index = serviceRoutes.findIndex(i => i.code === apl.aplCatl);
        const data = [{
            transactionItemName: apl.name,
            userChecked: true,
            transactionItemNo: apl.aplCatl,
            routeName: serviceRoutes[index].routeName,
        }];
        // for step route
        store.dispatch('services/setServices', data);
        // for 資料確認頁面
        store.dispatch('services/setTransactionItems', data);

        if (res.data?.compositeAccountFlag) {

            signBox1.show = true;
        } else {

            signBox2.show = true;
            // bailout.show = true;
        }

    }).catch((ex) => {
        console.log('@@' + ex.data?.customTitle);
        const msgTitle = (ex.data?.customTitle === '') ? '暫時無法使用雲端e櫃檯' : ex.data?.customTitle;
        openPopupCatch({
            title: msgTitle,
            confirmButton: '我知道了',
            error: ex,
            confirmFunction: () => {
                window.location.href = 'applink://back_home';
            },
        });
    }).finally(() => {
        pageData.isLoading = false;
    });
};

function removeByKey(array, key) {
    array.map(v => {
        if (v.key === key) {
            var index = array.indexOf(v);
            array.splice(index, 1);
        }
    })
}

function box(title, flexclass, list) {
    this.title = title;
    this.flexclass = flexclass;
    this.list = list;
}

function boxItem(key, value) {
    this.key = key;
    this.value = value;
}

function Link(text, to) {
    this.text = text;
    this.to = to;
}

const caseData = ref(null);
const tabIndex = ref(0);
if (route.params?.tab) {
    tabIndex.value = Number(route.params?.tab);
}
const goTab = (index) => {
    tabIndex.value = (index >= 2 || !index) ? 0 : index;
    if (Number(tabIndex.value) === 1) {
        showReserver();
    }
};

const showReserver = () => {
    var caseDataAi = ([]);
    pageData.isLoading = true;
    showReserverList().then((res) => {
        if (res.data != null && res.data.list.length > 0) {
            res.data.list.forEach(p => {
                let boxList1 = new box('', 'justify-between', [new boxItem('申請日期', p.transDate)
                    , new boxItem('申請項目', p.aplCatlText)
                    , new boxItem('保單號碼', p.fullPolicyNo)
                    , new boxItem('受理案號', p.regiNo)
                    , new boxItem('視訊時間', p.reserveTime)
                    , new boxItem('處理狀態', p.statusDesc),
                ]);
                let name;
                if (p.aplCatl === aplCatlCode.LOAN) {
                    name = routeName.CLOUD_E_COUNTER_RECORD_LOAN;
                    // 借款要將【處理狀態】欄位暫時刪除
                    removeByKey(boxList1.list, '處理狀態');
                } else if (p.aplCatl === aplCatlCode.APPLICANT_INSURED_NAME_CHANGE) {
                    name = routeName.CLOUD_E_COUNTER_RECORD_NAME;
                } else if (p.aplCatl === aplCatlCode.BENEIFCIARY) {
                    name = routeName.CLOUD_E_COUNTER_RECORD_BENEFICIARY;
                    if (!p.reserveTime) {
                        removeByKey(boxList1.list, '視訊時間');
                    }
                } else {
                    name = routeName.CLOUD_E_COUNTER_RECORD_APPLICANT_CHANGE;
                }

                var link1 = new Link(p.canCancel ? '查詢/取消申請內容' : '查詢申請內容', {
                    name: name,
                    query: { regiNo: p.regiNo },
                });
                caseDataAi.push({
                    boxList: [boxList1],
                    link: link1,
                });
            });
            caseData.value = caseDataAi;
        }
    }).catch((ex) => {
        console.log(ex);
    }).finally(() => {
        pageData.isLoading = false;
    });
};

const init = () => {
    pageData.isLoading = true;

    getPauseFunctionInfo().then(async (res) => {
        const reserveObject = res.data.pauseFunctionInfoList.find(i => i.aplCatl === 'CEC');
        if (reserveObject != null && reserveObject !== undefined) {
            checkMaintenance.value = true; 
            maintenance.message = reserveObject.content;
            maintenance.title = reserveObject.title;
            maintenance.show = true;

        } else {
            checkMaintenance.value = false; 
            goTab(tabIndex.value);
            getNoticeInfo().then(res => {
                noticeList.value = res.data.noticeList;
                if (noticeList.value.length > 0) {
                    visibleModal.value = true;
                }
            }).finally(() => {
                pageData.isLoading = false;
            });
        }
    }).finally(() => {
        pageData.isLoading = false;
    });

};
onMounted(() => {
    init();
});
</script>

<style scoped>
.tabs__btn.active {
    font-weight: bold;
}

.tabs__btn.active::after {
    content: '';
    display: block;
    width: 100%;
    height: 4px;
    position: absolute;
    bottom: 0;
    border-radius: 6px;
    background: #0093C1;
}
</style>